/**
 * Kaydın kökeni (EK1): ajan önerisinden insan onayıyla oluşan görev / randevu / teklif taslağı. Takvimde, aktivite ve teklif
 * kaydında köken etiketi olarak gösterilir. Konuşma bağlantısı yalnız kimlik taşır; içerik konuşmanın kendi yetkisiyle açılır.
 */
import { z } from 'zod';
export const recordOriginSchema = z.object({
    kind: z.literal('agent_suggestion'),
    suggestionId: z.string(),
    /** Öneri türü: task | appointment | quote_draft */
    suggestionKind: z.string(),
    /** Öneren ajan profili; test çalıştırıcısı ise `test` */
    agent: z.object({ id: z.string(), name: z.string(), test: z.boolean() }).nullable(),
    conversationId: z.string().nullable(),
    /** Onaylayan kullanıcı ve onay anı (kayıt aynı işlemde uygulanır) */
    approvedBy: z.object({ id: z.string(), name: z.string() }).nullable(),
    approvedAt: z.string().nullable(),
});
export const recordOriginResponseSchema = z.object({ origin: recordOriginSchema.nullable() });
/** Kısa köken etiketi (takvim, kart) */
export function recordOriginLabel(o) {
    return o.agent?.test === true ? 'Test ajanı önerisi' : 'Asistan önerisi';
}
//# sourceMappingURL=record-origin.js.map